import React from 'react';
import Images from '../assets/AllImages';

const mainData = [
    [
        {
            img: Images.EVENTS1,
            title: "Prishtina Open – International Swimming Competition",
            desc: "A regional highlight, welcoming top swimmers from across Europe. Three days of elite competition, team spirit, and record-breaking moments.",
        },
        {
            img: Images.EVENTS2,
            title: "Summer Splash Kids Festival",
            desc: "A fun-filled weekend for children with water games, safe swim zones, music, and interactive activities promoting healthy habits and joy.",
        },
        {
            img: Images.EVENTS3,
            title: "Winter Training Camp",
            desc: "A specialized camp for athletes and swim clubs, offering tailored programs, workshops, and world-class facilities during the off-season.",
        },
    ],
    [
        {
            img: Images.EVENTS4,
            title: "Family Wellness Weekend",
            desc: "An event designed for all ages – yoga sessions, aquatic games, family spa offers, and workshops focused on bonding through movement and mindfulness.",
        },
        {
            img: Images.EVENTS5,
            title: "Step Fit Challenge",
            desc: "An open fitness competition inviting the public to test their strength, endurance, and teamwork with exciting prizes and community recognition.",
        },
        {
            img: Images.EVENTS6,
            title: "Rehab & Recovery Expo",
            desc: "Focused on physical therapy and recovery techniques, this event brings professionals and visitors together for demos, talks, and free consultations.",
        },
    ],
    [
        {
            img: Images.EVENTS7,
            title: "Swim & Study Program Launch",
            desc: "Combining academics and athletics, this program kickoff invites parents and students to learn about our dual-track education and training initiative.",
        },
        {
            img: Images.EVENTS8,
            title: "Youth Swim League Finals",
            desc: "Celebrating the next generation of swimmers with exciting finals and awards, fostering motivation, discipline, and a love for sport.",
        },
        {
            img: Images.EVENTS9,
            title: "Women in Sports Day",
            desc: "A tribute to female athletes with guest speakers, training sessions, networking opportunities, and empowerment workshops.",
        },
    ],
    [
        {
            img: Images.EVENTS10,
            title: "Step Aqua Night Swim",
            desc: "An evening of ambient lights, chill music, and open swim under the stars. A unique aquatic experience for relaxation and connection.",
        },
        {
            img: Images.EVENTS11,
            title: "Corporate Wellness Day",
            desc: "Partnered with local businesses to provide teams with wellness seminars, group training, stress relief activities, and healthy meal plans.",
        },
        {
            img: Images.EVENTS12,
            title: "Inclusive Sports Week",
            desc: "Promoting equal access to sport with adapted programs for individuals with disabilities, hosted in collaboration with local NGOs and therapists.",
        },
    ],
];


const EVENTSCARDS = ({ img, title, desc }) => {
    return (
        <div className="col-12 col-md-4 col-sm-6">
            <div className="border rounded p-2 h-100 text-md-center">
                <img src={img} alt={title} className="w-100 mb-4" style={{ height: "180px", objectFit: "cover" }} />
                <h5 className='text-primary fw-bold'>{title}</h5>
                <p>{desc}</p>
                <span className="text-muted" style={{fontSize: "12px"}}>17.06.2025</span>
            </div>
        </div>
    );
};


const EVENTS = () => {
    return (
        <>
            <main>
                <div className="container-fluid bg-primary py-3 py-md-0">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 px-5">
                            <h5 className='text-white fw-bold my-0'>EVENTS</h5>
                        </div>
                        <div className="col-12 col-md-6 px-5 d-none d-sm-block">
                            <img src={Images.Vactor2} alt="" className='w-50 float-end' />
                        </div>
                    </div>
                </div>
            </main>

            <div className="container my-4">
                {mainData.map((group, idx) => (
                    <div className="row g-3 mb-4" key={idx}>
                        {group.map((item, i) => (
                            <EVENTSCARDS key={i} {...item} />
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
};

export default EVENTS;
